<template>
  <v-menu offset-y
  :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        text
        v-on="on"
      >
        {{ rowsPerPage }}
        items
      </v-btn>
    </template>
    <v-card class="pa-2">

      <v-layout justify-center>
        <span class="caption text-uppercase text--text text--darken-1">Items per page</span>
      </v-layout>

      <div class="c-hr ma-2"></div>

      <v-layout align-center>

        <v-btn
        icon
        @click="computedRowsPerPageTV--">
          <v-icon color="color1">mdi-minus</v-icon>
        </v-btn>

        <v-text-field
        v-model="computedRowsPerPageTV"
        hide-details
        :class="['font-weight-bold mt-0 pt-0', {'red--text': rowsPerPage !== parseInt(rowsPerPageTV)}]"
        style="max-width: 70px;"
        >
        </v-text-field>

        <v-btn
        icon
        @click="computedRowsPerPageTV++">
          <v-icon color="color1">mdi-plus</v-icon>
        </v-btn>

      </v-layout>

      <v-list>

        <v-list-item
        @click="computedRowsPerPageTV = 5">
          <v-list-item-title
          :class="[{'color1--text' : computedRowsPerPageTV === 5}]">
            5
          </v-list-item-title>
        </v-list-item>

        <v-list-item
        @click="computedRowsPerPageTV = 10">
          <v-list-item-title
          :class="[{'color1--text' : computedRowsPerPageTV === 10}]">
            10
          </v-list-item-title>
        </v-list-item>

        <v-list-item
        @click="computedRowsPerPageTV = 20">
          <v-list-item-title
          :class="[{'color1--text' : computedRowsPerPageTV === 20}]">
            20
          </v-list-item-title>
        </v-list-item>

      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: ['page', 'rowsPerPage', 'rowsPerPageTV'],
  computed: {
    computedRowsPerPageTV: {
      get () {
        return this.rowsPerPageTV
      },
      set (nv) {
        console.log('hello')
        console.log(isNaN(nv))
        if (isNan(nv) || nv < 2 || nv > 50) {
          return
        }
        this.$emit('update:rowsPerPageTV', nv)
      }
    },
    pageIndex () {
      if (this.page === 0) {
        return 1
      }
      return ((this.page - 1) * this.rowsPerPage) + 1
    }
  }
}
</script>

